import {LastBuildChart} from '../components/LastBuildChart.js';
import {TestResultTable} from '../components/TestResultTable.js';

import {repoName, buildLink} from '../helpers/helpers.js';

import React, {Component} from "react";
import jquery from 'jquery';
import MDSpinner from "react-md-spinner";

export class RepoBuildDisplay extends Component {
  constructor(props) {
    super(props);
    this.state = { build: null };
  }

  render() {
    if (this.props.buildId === null) {
      return (
          <div>
            <h2>Please select a build</h2>
          </div>);
    }

    if (this.state.build === null) {
      return (
          <div>
            <p>Build with id {this.props.buildId} is loading. <MDSpinner/></p>
          </div>);
    }

    const build = this.state.build;
    const thisRepoName = repoName(build.repo_url);
    return (
     <div className="build-display">
      <div className="table-responsive">
        <h2>Build Information</h2>
        <table className="table"><tbody>
          <tr><td>Repo</td>
            <td><i className="fa fa-github" aria-hidden="true"/> <a href={build.repo_url}>{thisRepoName}</a></td>
          </tr>
          <tr><td>Commit</td>
            <td><i className="fa fa-github" aria-hidden="true"/> <a href={build.repo_url + "/commit/" + build.commit}>{this.state.build.commit}</a></td>
          </tr>
          <tr><td>Overview</td><td><a href={"/r/gh/" + thisRepoName}>{thisRepoName}</a></td></tr>
          <tr><td>Branch</td><td>{build.branch}</td></tr>
          <tr><td>OS</td><td>{this.state.build.os_name}</td></tr>
          <tr><td>CI System</td><td>{this.state.build.ci_system}</td></tr>
          <tr><td>CI Build</td>
            <td><a href={buildLink(build.repo_url, build.ci_system, build.job_id)}>#{this.state.build.build_number}</a>
          </td></tr>
          <tr><td>Tests</td><td>{this.state.build.testCount}</td></tr>
          <tr><td>Badge</td><td><img alt="Badge with number of tests" src={"https://api.bob-bench.org/v1/badge/" + build.repo_id + "?branch=" + build.branch + "&ci=" + build.ci_system + "&subNumber=" + build.build_sub}/></td></tr>
        </tbody></table>
      </div>
      <div className="chart-col">
        <h2>Graphs</h2>
        <LastBuildChart buildId={build.id} parentId={build.parent_id} ci_system={build.ci_system} sub_number={this.props.sub_number}/>
      </div>
        <h2>Tests</h2>
        <div className="table-responsive">
	  <TestResultTable results={build.json}/>
        </div>
     </div>);
  }

  componentDidMount() {
    this.queryBuild(this.props.buildId);
  }

  componentWillReceiveProps(nextProps) {
    /* check if it actually changed */
    if (nextProps.buildId === this.props.buildId)
      return;

    this.queryBuild(nextProps.buildId);
  }

  queryBuild(buildId) {
    jquery.getJSON('https://api.bob-bench.org/v1/run/' + buildId)
      .done(function(data) {
        this.setState({build: data});
      }.bind(this))
      .fail(function(error, a, b) {
      });
  }
};



// WEBPACK FOOTER //
// ./src/views/RepoBuildDisplay.js